import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraButton, SpecraIconTile } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { FileText, PencilLine } from 'lucide-react';
import { asOfficeDocType, useOfficeDocumentDrawer } from '../../../contexts/OfficeDocumentDrawerContext';
/** Tools that mint a real Office file (shirohige) and should open in OnlyOffice. */ export const OFFICE_MINT_TOOL_IDS = [
    'create-office-document',
    'sam-awards-query',
    'sam-track-vendor-footprint',
    'sam-find-incumbents',
    'sam-get-contract-rundown',
    'sam-recompete-forecasting',
    // `data` mints only when its pipeline ends in `office xlsx`; rows otherwise.
    'data'
];
export function isOfficeMintTool(name) {
    return OFFICE_MINT_TOOL_IDS.includes(name);
}
/**
 * Renders a minted Office file in chat (create-office-document or a SAM awards
 * Excel tool) plus an "Open in editor" action that launches the OnlyOffice
 * drawer. Pending create proposals open their draft preview from
 * DocumentCreateCard; this card is only the receipt for a document that
 * already exists.
 */ export function CreateOfficeDocumentCard({ output }) {
    const { openOffice } = useOfficeDocumentDrawer();
    const success = output?.success === true;
    const documentId = output?.documentId;
    const name = output?.name || 'Document';
    const docType = asOfficeDocType(output?.documentType);
    if (!success || !documentId) {
        return /*#__PURE__*/ _jsx("div", {
            "data-testid": Testids.assistant.createOfficeDocumentCard,
            className: "rounded-md border border-gray-200 bg-white p-3 text-sm text-gray-600",
            children: output?.message || 'Could not create the document.'
        });
    }
    const typeLabel = docType ? docType.toUpperCase() : 'Office';
    return /*#__PURE__*/ _jsxs("div", {
        "data-testid": Testids.assistant.createOfficeDocumentCard,
        className: "flex items-center gap-3 rounded-md border border-border bg-card p-3",
        children: [
            /*#__PURE__*/ _jsx(SpecraIconTile, {
                tone: "neutral",
                className: "text-foreground",
                children: /*#__PURE__*/ _jsx(FileText, {
                    className: "h-4 w-4"
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "min-w-0 flex-1",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "truncate text-[13px] font-medium text-foreground",
                        title: name,
                        children: name
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "text-[11.5px] text-muted-foreground",
                        children: [
                            "Created a ",
                            typeLabel,
                            " document"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(SpecraButton, {
                size: "sm",
                "data-testid": Testids.assistant.createOfficeDocumentOpenButton,
                onClick: ()=>openOffice(documentId, {
                        title: name,
                        docType
                    }),
                iconLeft: /*#__PURE__*/ _jsx(PencilLine, {
                    className: "h-3.5 w-3.5"
                }),
                children: "Open in editor"
            })
        ]
    });
}
